import {
  useSuspenseQuery,
  splitQueryParams,
  queryFn,
} from "source/registrations/utils/queryCache"

export const useOrganization = (options = {}) => {
  const path = "/registrations/v2"
  const { params, queryOptions } = splitQueryParams(options)

  return useSuspenseQuery({
    queryFn,
    queryKey: [path, params],
    ...queryOptions,
  })
}

export const useOrganizationFlag = (name, options) => {
  const { data } = useOrganization(options)
  return data?.productFeatures[name] || false
}

export const useOrganizationSetting = (name, options) => {
  const { data } = useOrganization(options)
  return data?.settings[name] || null
}
